import { Component } from 'react'
import Autosuggest from 'react-autosuggest'
import debounce from 'lodash/debounce'
import { FormattedMessage, intlShape, injectIntl, defineMessages } from 'react-intl'
import { toast } from 'react-toastify'
import API from '../../api'
import { getHighlightedText } from '../helpers/Typeahead';

const msg = defineMessages({
  name_or_location: {
    id: 'name_or_location',
    defaultMessage: 'Name or location',
  },
  near_me: {
    id: 'near_me',
    defaultMessage: 'Near me',
  },
  radius_km: {
    id: 'radius_km',
    defaultMessage: '50 km radius',
  },
})

const renderIcon = (type) => {
  if(type === 'near_by') {
    return 'best-choice-icon'
  } else if(type === 'place') {
    return 'location-icon'
  }
  return 'dive-center-icon'
}

const renderSuggestion = (suggestion, { query }) =>
  (<div className={`typeahead-item ${suggestion.last ? 'last' : ''}`}>
    <div className='img-wrap'>
      <i className={`font-icons ${renderIcon(suggestion.objectType)}`} />
    </div>
    <div className='typeahead-title'>
      <span className='location-title'>{getHighlightedText(suggestion.title, query)}</span>
      <span className='location-text'>{getHighlightedText(suggestion.name, query) || ' '}</span>
    </div>
  </div>)

class TripOrganiser extends Component {
  constructor(props) {
    super(props)

    this.nearMeChoice = {
      id: 'near_by',
      searchParam: 'near_by',
      objectType: 'near_by',
      title: this.props.intl.formatMessage(msg.near_me),
      name: this.props.intl.formatMessage(msg.radius_km),
    }
    this.state = {
      value: props.inputValue || '',
      suggestions: [this.nearMeChoice],
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.inputValue !== this.props.inputValue) {
      this.setState({
        value: this.props.inputValue || '',
      })
    }
  }
  controller
  signal

  getSuggestionValue = suggestion => {
    if(suggestion.objectType === 'near_by') {
      navigator.geolocation.getCurrentPosition((location) => {
        if(typeof this.props.callback === 'function') {
          this.props.callback({
            [suggestion.searchParam]: `${location.coords.latitude},${location.coords.longitude}`,
            organiserTitle: this.props.intl.formatMessage(msg.near_me),
            isNearBy: true,
            place_id: undefined,
            organiser_pk: undefined,
          })
        }
      }, function() {
        toast.error(<FormattedMessage id='cant_get_location' defaultMessage='Unfortunately we can`t receive your coordinates' />, {
          position: toast.POSITION.TOP_CENTER,
        })
      })
    } else {
      this.props.callback({
        place_id: undefined,
        organiser_pk: undefined,
        [suggestion.searchParam]: suggestion.pk,
        organiserTitle: suggestion.title,
      })
    }
    return suggestion.title
  }

  onSuggestionsFetchRequested = debounce(({ value }) => {
    const { model, pk } = this.props

    if(this.controller !== undefined) {
      // Cancel the previous request
      this.controller.abort()
    }

    if('AbortController' in window) {
      this.controller = new window.AbortController()
      this.signal = this.controller.signal
    }
    return API(`search/${model.toLowerCase()}/${pk}/organisers/`, this.signal).get({
      search: value,
    }).then((suggestions) => {
      suggestions.push(this.nearMeChoice)
      this.setState({
        suggestions,
      })
    })
  }, 300)

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [this.nearMeChoice],
    })
  }

  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue,
    }, () => {
      if(newValue.length === 0) {
        this.onSuggestionsClearRequested()
        this.props.callback({
          place_id: undefined,
          organiser_pk: undefined,
          organiserTitle: undefined,
          near_by: undefined,
        })
      }
    })
  }

  render() {
    const { value, suggestions } = this.state
    const inputProps = {
      placeholder: this.props.intl.formatMessage(msg.name_or_location),
      value,
      autoComplete: 'off',
      onChange: this.onChange,
      onBlur: () => {
        if(this.popup) {
          this.popup.style.opacity = 0

          setTimeout(() => {
            this.popup.style.left = '-9999px'
          }, 300)
        }
      },
      onFocus: (e) => {
        try {
          e.currentTarget.setSelectionRange(0, value.length)
        } catch (err) {
          // Non IOs option if not supported, e.g. Chrome
          e.currentTarget.select()
        }

        if(this.popup) {
          if(value.length < 3) {
            this.popup.style.opacity = 1
            this.popup.style.left = this.inputOffset.left + 'px'
            this.popup.style.top = this.inputOffset.top + 45 + 'px'
          }
        }
      },
    }
    return <Autosuggest
      suggestions={suggestions}
      onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
      onSuggestionsClearRequested={this.onSuggestionsClearRequested}
      getSuggestionValue={this.getSuggestionValue}
      renderSuggestion={renderSuggestion}
      inputProps={inputProps}
    />
  }
}

TripOrganiser.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(TripOrganiser)
